import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesStoreComponent} from "./sales-store.component";
import {GeneralModule} from "../general/general.module";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";



@NgModule({
  declarations: [
    SalesStoreComponent
  ],
  imports: [
    CommonModule,
    GeneralModule,
    PrimengModule,
    LibraryModule
  ],
  exports: [
    SalesStoreComponent
  ]
})
export class SalesStoreModule { }
